import { Grid } from '@mui/material'

import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import PageUrls from '../../../../constants/page-urls'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import OrderQuickCreateOldCard from './components/OrderQuickCreateOldCard'
import useAxios from '../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../types/pagination'
import { IOrderMessage } from '../../../../types/order-message'
import { useState } from 'react'
import OrderQuickCreateOldListTable, { IFilterMapped } from './components/OrderQuickCreateOldListTable'

const Menus: any[] = []

const OrderQuickCreateOld = () => {
  const [filter, setFilter] = useState<IFilterMapped>({
    page: 1,
    perPage: 15,
  })
  const orderMessageList = useAxios<PaginationResponseInterface<IOrderMessage>>({
    method: 'GET',
    url: '/order/order-fetch-message',
    params: filter
  })

  const onUpdateSuccess = async () => {
    await orderMessageList.mutate()
  }

  return (
    <ContentWrapper>
      <Helmet title="คำสั่งซื้อใหม่ (ด่วน)" />
      <HeaderContent
        goBack
        title="คำสั่งซื้อใหม่ (ด่วน)"
        routes={Menus}
        descriptions="รายการคำสั่งซื้อสินค้า"
      >
      </HeaderContent>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={5}>
          <OrderQuickCreateOldCard
            isLoading={orderMessageList.isLoading}
            onUpdateSuccess={onUpdateSuccess}
          />
        </Grid>
        <Grid item xs={12} lg={7}>
          <OrderQuickCreateOldListTable
            isLoading={orderMessageList.isLoading}
            onFilterChange={setFilter}
            filter={filter}
            data={orderMessageList.data?.records}
            total={orderMessageList.data?.count}
          />
        </Grid>
      </Grid>
    </ContentWrapper>
  )

}

export default OrderQuickCreateOld
